<!--
통계 컴포넌트, CampaignDetail의 하위
-->
<template>
  <div>
    <div class="not-yet-start" v-if="status === 'disabled'">
      <div>예약된 광고입니다.</div>
      <div>광고 후 통계 확인이 가능합니다.</div>
    </div>
    <div v-else>
      <div class="download-link-wrap">
        <span class="excel-download" @click="doDownloadExcel"
          ><i class="fas fa-table"></i> 통계자료 엑셀로 다운로드</span
        >
      </div>

      <div class="cards">
        <statistics-card title="전체 조회수" :value="view" :raf="true" />
        <statistics-card title="전체 클릭수" :value="click" :raf="true" />
        <statistics-card title="CTR(클릭률)" :value="`${totalPercentage}%`" />
      </div>

      <!-- pie chart -->
      <statistics-pie-chart :chartData="pieData" />

      <!-- text table chart -->
      <statistics-table-chart
        :statistic="statistic && statistic.campaign_item_stat"
        :itemStatistics="itemStatistics"
      />

      <!-- line chart -->
      <statistics-line-chart :chartData="chartData" :statistic="statistic" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import * as Exceljs from "exceljs";
import FileSaver from "file-saver";

import StatisticsCard from "@/components/campaign/StatisticsCard";

import StatisticsPieChart from "@/components/campaign/StatisticsPieChart";
import StatisticsTableChart from "@/components/campaign/StatisticsTableChart";
import StatisticsLineChart from "@/components/campaign/StatisticsLineChart";

export default {
  name: "CampaignStatistic",
  data: () => ({
    typeMap: ["띠형배너", "팝업배너", "이벤트", "푸시알림"],
    type: "view",
    view: 0,
    click: 0,
    totalPercentage: 0,
    totalStat: {
      rate: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
      },
    },
    stats: {},
    chartData: {
      columns: null,
      rows: [],
    },
    pieData: {
      columns: ["type", "value"],
      rows: [],
    },
  }),
  props: {
    title: String,
    start: String,
    end: String,
    status: String,
  },
  computed: {
    ...mapState({
      statistic: "statistic",
    }),

    ...mapGetters({
      itemStatistics: "itemStatistics",
    }),
  },
  mounted() {
    this.FETCH_DATA();
  },
  components: {
    StatisticsCard,
    StatisticsPieChart,
    StatisticsTableChart,
    StatisticsLineChart,
  },
  methods: {
    ...mapActions(["FETCH_STATISTIC"]),

    async doDownloadExcel() {
      const height = 22;
      const workbook = new Exceljs.Workbook();
      const worksheet = workbook.addWorksheet("통계");

      const titleStyle = {
        alignment: {
          horizontal: "center",
          vertical: "middle",
        },
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF3F3F3" },
          bgColor: { argb: "FFF3F3F3" },
        },
      };

      const style = {
        alignment: {
          horizontal: "center",
          vertical: "middle",
        },
      };

      worksheet.getRow(1).height = height;
      worksheet.getRow(4).height = height;
      worksheet.getRow(7).height = height;
      worksheet.getRow(11).height = height;

      worksheet.mergeCells(1, 1, 1, 4);
      worksheet.mergeCells(1, 5, 1, 8);
      worksheet.getRow(1).getCell(1).value = "제목";
      worksheet.getRow(1).getCell(1).style = titleStyle;
      worksheet.getRow(1).getCell(5).value = "기간";
      worksheet.getRow(1).getCell(5).style = titleStyle;

      worksheet.mergeCells(2, 1, 2, 4);
      worksheet.mergeCells(2, 5, 2, 8);
      worksheet.getRow(2).getCell(1).value = this.title;
      worksheet.getRow(2).getCell(1).style = style;
      worksheet.getRow(2).getCell(5).value = this.start + " - " + this.end;
      worksheet.getRow(2).getCell(5).style = style;

      worksheet.mergeCells(4, 1, 4, 2);
      worksheet.mergeCells(4, 4, 4, 5);
      worksheet.mergeCells(4, 7, 4, 8);
      worksheet.getRow(4).getCell(1).value = "전체조회수";
      worksheet.getRow(4).getCell(1).style = titleStyle;
      worksheet.getRow(4).getCell(4).value = "전체클릭수";
      worksheet.getRow(4).getCell(4).style = titleStyle;
      worksheet.getRow(4).getCell(7).value = "CTR(클릭수)";
      worksheet.getRow(4).getCell(7).style = titleStyle;

      worksheet.mergeCells(5, 1, 5, 2);
      worksheet.mergeCells(5, 4, 5, 5);
      worksheet.mergeCells(5, 7, 5, 8);
      worksheet.getRow(5).getCell(1).value = this.view;
      worksheet.getRow(5).getCell(1).style = style;
      worksheet.getRow(5).getCell(4).value = this.click;
      worksheet.getRow(5).getCell(4).style = style;
      worksheet.getRow(5).getCell(7).value = this.totalPercentage + "%";
      worksheet.getRow(5).getCell(7).style = style;

      worksheet.mergeCells(7, 1, 7, 8);
      worksheet.getRow(7).getCell(1).value = "항목별 클릭 비율";
      worksheet.getRow(7).getCell(1).style = titleStyle;

      for (let i = 0; i < 4; i++) {
        const ci = i * 2 + 1;

        worksheet.mergeCells(8, ci, 8, ci + 1);
        worksheet.getRow(8).getCell(ci).value = this.typeMap[i];
        worksheet.getRow(8).getCell(ci).style = style;

        worksheet.mergeCells(9, ci, 9, ci + 1);

        const pieDataRowsIndex = this.pieData.rows.findIndex(
          ({ type }) => type === this.typeMap[i]
        );

        if (pieDataRowsIndex === -1) {
          worksheet.getRow(9).getCell(ci).value = "없음";
        } else {
          worksheet.getRow(9).getCell(ci).value =
            this.pieData.rows[pieDataRowsIndex].value + "%";
        }

        worksheet.getRow(9).getCell(ci).style = style;

        worksheet.mergeCells(12, ci, 12, ci + 1);
        worksheet.getRow(12).getCell(ci).value = this.typeMap[i];
        worksheet.getRow(12).getCell(ci).style = style;
      }

      worksheet.mergeCells(11, 1, 11, 8);
      worksheet.getRow(11).getCell(1).value = "통계 테이블";
      worksheet.getRow(11).getCell(1).style = titleStyle;

      for (let i = 1; i <= 8; i++) {
        worksheet.getRow(13).getCell(i).value = i % 2 === 0 ? "click" : "view";
        worksheet.getRow(13).getCell(i).style = style;
      }

      let si = 14; // Start Index

      const bannerIndex = this.itemStatistics[0].findIndex(
        ({ data }) => data === "띠형배너"
      );
      const popupIndex = this.itemStatistics[0].findIndex(
        ({ data }) => data === "팝업배너"
      );
      const eventIndex = this.itemStatistics[0].findIndex(
        ({ data }) => data === "이벤트"
      );
      const pushIndex = this.itemStatistics[0].findIndex(
        ({ data }) => data === "푸시알림"
      );

      for (let i = 1; i < this.itemStatistics.length; i++) {
        const date = this.itemStatistics[i][0].data.date;
        const banner = this.itemStatistics[i][bannerIndex];
        const popup = this.itemStatistics[i][popupIndex];
        const event = this.itemStatistics[i][eventIndex];
        const push = this.itemStatistics[i][pushIndex];

        if (this.itemStatistics.length === i + 1) {
          worksheet.mergeCells(si, 1, si, 8);
          worksheet.getRow(si).height = height;
          worksheet.getRow(si).getCell(1).style = titleStyle;
          worksheet.getRow(si).getCell(1).value = "총합";
          si++;
        }

        worksheet.getRow(si).getCell(1).value =
          banner && banner.data ? banner.data.view : "-";
        worksheet.getRow(si).getCell(2).value =
          banner && banner.data ? banner.data.click : "-";
        worksheet.getRow(si).getCell(3).value =
          popup && popup.data ? popup.data.view : "-";
        worksheet.getRow(si).getCell(4).value =
          popup && popup.data ? popup.data.click : "-";
        worksheet.getRow(si).getCell(5).value =
          event && event.data ? event.data.view : "-";
        worksheet.getRow(si).getCell(6).value =
          event && event.data ? event.data.click : "-";
        worksheet.getRow(si).getCell(7).value =
          push && push.data ? push.data.view : "-";
        worksheet.getRow(si).getCell(8).value =
          push && push.data ? push.data.click : "-";

        if (this.itemStatistics.length !== i + 1) {
          worksheet.getRow(si).getCell(9).value = date;
        }

        worksheet.getRow(si).getCell(1).style = style;
        worksheet.getRow(si).getCell(2).style = style;
        worksheet.getRow(si).getCell(3).style = style;
        worksheet.getRow(si).getCell(4).style = style;
        worksheet.getRow(si).getCell(5).style = style;
        worksheet.getRow(si).getCell(6).style = style;
        worksheet.getRow(si).getCell(7).style = style;
        worksheet.getRow(si).getCell(8).style = style;

        si++;
      }

      try {
        const buffer = await workbook.xlsx.writeBuffer();
        FileSaver.saveAs(new Blob([buffer]), `${this.title} - 광고통계.xlsx`);
      } catch (err) {
        this.$alert.error(err.message);
      }
    },

    async FETCH_DATA() {
      this.FETCH_STATISTIC({ idx: this.$route.params.id }).then(() => {
        let totalStat = this.statistic.campaign_total_stat;

        for (let i in totalStat) {
          if (totalStat[i].hasOwnProperty("type")) {
            // use pieData
            this.pieData.rows.push({
              type: this.typeMap[totalStat[i].type],
              value: totalStat[i].item_rate,
            });
          } else if (totalStat[i].hasOwnProperty("total_rate")) {
            this.totalPercentage = totalStat[i].total_rate;
          } else {
            this.view = totalStat[i].total_view;
            this.click = totalStat[i].total_click;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.cards {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

@media (max-width: $min_layout) {
  .cards {
    flex-direction: column;
  }
}

.not-yet-start {
  padding-top: 4rem;
  padding-left: 1.6rem;
  font-size: 1.7rem;
  line-height: 1.7;
}

.download-link-wrap {
  width: 100%;
  text-align: center;
  padding: 16px 0;
}

.excel-download {
  font-size: 14px;
  color: #009c05;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
